import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
// import Vant from 'vant'
// import { Lazyload } from 'vant'
// import 'vant/lib/index.css'
import './assets/css/common.css'
import Api from './assets/js/api.js'
import Qiniu from './assets/js/qiniu.js'
import App from './App.vue'
import VueClipboard from 'vue-clipboard2'


Vue.prototype.$api = Api
Vue.prototype.$qiniu = Qiniu
Vue.config.productionTip = false
// Vue.use(Vant)
// Vue.use(Lazyload)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueClipboard)


const Routers = [
  {
    path: '/',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/mails_square.vue'], resolve)
  },
  {
    path: '*',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/not_found.vue'], resolve)
  },
  {
    path: '/loading',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/loading.vue'], resolve)
  },
  {
    path: '/loading_base',
    meta: {
      title: ' '
    },
    component: (resolve) => require(['./views/loading_base.vue'], resolve)
  },
  {
    path: '/rules_user_protocal',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/rules_user_protocal.vue'], resolve)
  },
  {
    path: '/rules_privacy',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/rules_privacy.vue'], resolve)
  },
  {
    path: '/not_found',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/not_found.vue'], resolve)
  },
  {
    path: '/mails_square',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/mails_square.vue'], resolve)
  },
  {
    path: '/mail_create',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/mail_create_wechat.vue'], resolve)
  },
  {
    path: '/mail_revise/:id',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/mail_revise.vue'], resolve)
  },
  {
    path: '/parcel_create',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/parcel_create.vue'], resolve)
  },
  {
    path: '/parcel_revise/:id',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/parcel_revise.vue'], resolve)
  },
  {
    path: '/parcel_create_douyin',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/parcel_create_douyin.vue'], resolve)
  },
  {
    path: '/parcel_revise_douyin/:id',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/parcel_revise_douyin.vue'], resolve)
  },
  {
    path: '/mail_submitted_success/:mail_type',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/mail_submitted_success_v2.vue'], resolve)
  },
  {
    path: '/mails_records',
    meta: {
      title: '我写的信'
    },
    component: (resolve) => require(['./views/mails_records_v2.vue'], resolve)
  },
  {
    path: '/mail_notepaper/:id',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/mail_notepaper.vue'], resolve)
  },
  {
    path: '/test_garden',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/test_garden.vue'], resolve)
  },
  {
    path: '/tuodan_pay_h5/:mini_openid',
    meta: {
      title: ' '
    },
    component: (resolve) => require(['./views/tuodan_pay_h5.vue'], resolve)
  },
  {
    path: '/qrcode_for_waimaiqun',
    meta: {
      title: '省钱群'
    },
    component: (resolve) => require(['./views/qrcode_for_waimaiqun.vue'], resolve)
  },
  {
    path: '/ele',
    meta: {
      title: '饿了么翻倍红包'
    },
    component: (resolve) => require(['./views/ele.vue'], resolve)
  },
  {
    path: '/eleme',
    meta: {
      title: '饿了么翻倍红包'
    },
    component: (resolve) => require(['./views/eleme.vue'], resolve)
  },
  {
    path: '/tao',
    meta: {
      title: '淘宝外卖红包'
    },
    component: (resolve) => require(['./views/taobao_shangou.vue'], resolve)
  },
  {
    path: '/tao_pyq',
    meta: {
      title: '淘宝外卖红包'
    },
    component: (resolve) => require(['./views/taobao_shangou_pyq.vue'], resolve)
  },
  {
    path: '/tao_gzh',
    meta: {
      title: '淘宝外卖红包'
    },
    component: (resolve) => require(['./views/taobao_shangou_gzh.vue'], resolve)
  },
  {
    path: '/tao_hi',
    meta: {
      title: '淘宝外卖红包'
    },
    component: (resolve) => require(['./views/taobao_shangou_hi.vue'], resolve)
  },
  {
    path: '/tao_qun',
    meta: {
      title: '淘宝外卖红包'
    },
    component: (resolve) => require(['./views/taobao_shangou_qun.vue'], resolve)
  },
  {
    path: '/tao_die',
    meta: {
      title: '淘宝叠加红包'
    },
    component: (resolve) => require(['./views/taobao_shangou_diejia.vue'], resolve)
  },
  {
    path: '/qrcode_for_wiki',
    meta: {
      title: '课代表'
    },
    component: (resolve) => require(['./views/qrcode_for_wiki.vue'], resolve)
  }
]

const RouterConfig = {
  mode: 'history',
  routes: Routers
}
const router = new VueRouter(RouterConfig)

const store = new Vuex.Store({
  state: {
    userinfo: {
      headimg: '',
      nickname: '',
      openid: '',
      subscribe: 0,
      silent: 0,
      notice: true
    },
    mail_draft: {
      sender: '',
      receiver: '',
      content: '',
      square: '',
      schedule: ''
    },
    favicon: 'https://static.langmanyuan.com/960401561.jpg',
    staticUrl: 'https://static.huiyiji520.com',
    siteDomain: 'https://moment.huiyiji520.com',
    webAuthUrl: 'https://love.huiyiji520.com/momentbox',
    siteTitle: '西柚信箱',
    siteSlogan: '寄一封信给未来的自己或TA',
    siteCode: '',
    referal: '/'
  },

  mutations: {
    setUserinfo(state, params){
      // alert('nickname: ' + params.nickname)
      state.userinfo = {headimg: params.headimg, nickname: params.nickname, openid: params.openid, subscribe: params.subscribe, silent: params.silent, notice: params.notice}
      // alert('user block: ' + params.block)
      if(params.block == 1){
        router.replace('/not_found')
      }else if(params.destination){
        router.replace(params.destination)
      }
    },
    setUserinfoBase(state, params){
      state.userinfo = {openid: params.openid}
      router.replace(params.destination)
    },
    setReferal(state, params){
      state.referal = params.referal
    },
    setMailDraft(state, params){
      state.mail_draft = { sender: params.sender, receiver: params.receiver, content: params.content, square: params.square, schedule: params.schedule }
    }
  }
});

router.beforeEach((to, from, next) => {
  // alert('store state userinfo openid: ' + store.state.userinfo.openid)
  // alert('from path: ' + JSON.stringify(from.path))
  window.document.title = to.meta.title || store.state.siteTitle
  if(
    (to.path === "/loading") || (to.path === "/loading_base") || (to.path === "/") ||
    (to.path.indexOf("/mail_notepaper") >= 0) || (to.path === "/qrcode_for_waimaiqun") ||
    (to.path === "/ele") || (to.path === "/eleme") || (to.path === "/tao") ||
    (to.path === "/tao_pyq") || (to.path === "/tao_gzh") || (to.path === "/tao_hi") ||
    (to.path === "/tao_qun") || (to.path === "/tao_die") || (to.path === "/qrcode_for_wiki")
  ){
    next()
  }else if(from.path === "/mail_submitted_success"){
    router.replace('/')
  }else if(store.state.userinfo.openid){
    next()
  }else if(to.path.indexOf("/tuodan_pay_h5") >= 0){
    window.location.replace("https://api.huiyiji520.com/api/momentbox/snsapi_base?url=" + store.state.webAuthUrl + "/loading_base?destination=" + encodeURIComponent(to.fullPath))
  }else{
    // next()
    window.location.replace("https://api.huiyiji520.com/api/momentbox/snsapi_userinfo?url=" + store.state.webAuthUrl + "/loading?destination=" + encodeURIComponent(to.fullPath))
  }
})

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => {
    return h(App)
  }
})

window.onresize = setHtmlFontSize
function setHtmlFontSize () {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  const htmlDom = document.getElementsByTagName('html')[0]
  htmlDom.style.fontSize = htmlWidth / 10 + 'px'
}
setHtmlFontSize()


// // Disable right-click
// document.addEventListener('contextmenu', (e) => e.preventDefault());
//
// function ctrlShiftKey(e, keyCode) {
//   return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
// }
//
// document.onkeydown = (e) => {
//   // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
//   if (
//     event.keyCode === 123 ||
//     ctrlShiftKey(e, 'I') ||
//     ctrlShiftKey(e, 'J') ||
//     ctrlShiftKey(e, 'C') ||
//     (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
//   )
//     return false;
// };
